import { PlaylistItemData } from "./PlaylistItemData";
import { LookupSongFunction } from "../../common/LookupSongFunction";
import { SongUb } from "../../gql/graphql";

/** A playlist as the UI shows it. Comes from the GraphQL cache, or from the URL of a scanned QR code. */
class PlaylistData {
  public constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly belongsToCrew: string | undefined,
    private readonly tags: readonly string[],
    private readonly items: PlaylistItemData[],
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
    public readonly isPreview: boolean,
  ) {}

  public static createTimestampTag(timestamp: Date): string {
    return (
      timestamp.getFullYear() +
      "/" +
      (timestamp.getMonth() + 1) +
      "/" +
      timestamp.getDate()
    );
  }

  get titleLowercase(): string {
    return this.title.toLowerCase();
  }

  public getTags() {
    return structuredClone(this.tags);
  }

  public getItems(): PlaylistItemData[] {
    return this.items;
  }

  public getAllValidSongEntries(
    lookupSong: LookupSongFunction,
  ): readonly SongUb[] {
    const validEntries: SongUb[] = [];
    this.items.forEach((v) => {
      const song = lookupSong(v.songEntryId);
      if (song) validEntries.push(song);
    });
    return validEntries;
  }
}

export default PlaylistData;
